<template>
	<div>
		<myheader :backIntercept="true" @childBackEvent="back" headTitle="企业认证"></myheader>
		<div class="header_extend_main" style="height: 100%;padding-bottom: 5.4rem;">
			<div class="header_extend_back"></div>
			<div class="header_extend_content_height vertical_flex">
				<div class="all_tips_content_card_padding8">
					<div class="text12 textcolormain font_weight_bold">选择组织类型</div>
					<span class="text12 textcolormain" style="position: absolute;right: .5rem; top: .8rem;"
						@click="flow_path_show = true">查看流程</span>
					<div class="all_tips_input display_flex margin_top_5">
						<div class="width_flex all_height_line16 text14 textcolor333 font_weight_900">
							{{organizationalTypeText}}
						</div>
						<div class="selectstyle all_height_line16 text14 textcolor333 font_weight_900 display_flex"
							style="padding-left: 2.6rem;" @click="showSelectOrg()"></div>
					</div>
					<div class="text10 textcolor999 margin_top_1">
						{{organizationalTypeTips}}
					</div>
				</div>
				<div style="flex: 1;position: relative;border-radius: .3rem;" class="margin_top_8">
					<div style="overflow-y: auto;position: absolute;top: 0;left: 0;right: 0;bottom: 0;">
						<div class="all_tips_content_card_padding8 display_flex">
							<div class="display_block all_text_center" style="width: 50%;">
								<div class="all_text text12 font_weight_900 textcolor333">
									{{organizationalType === 0?'企业营业执照':'登记证书'}}
								</div>
								<div class="all_text_center margin_top_2">
									<van-uploader accept="image/*" v-model="businessLicense" :before-read="beforeRead"
										:after-read="afterReadBL" preview-size="7rem"
										:preview-full-image="licenseFilePreview">
										<img v-show="businessLicense.length==0"
											style="width: 7rem;height: 7rem;object-fit: contain;"
											src="@/assets/images/business_license_default.svg">
									</van-uploader>
									<div class="text12 textcolor333 margin_top_2">点击拍照/上传</div>
								</div>
							</div>
							<div class="display_block all_text_center" style="width: 50%;">
								<div class="all_text text12 font_weight_900 textcolor333">法人身份证照片</div>
								<div class="vertical_flex flex_wrap margin_top_2">
									<div class="all_text_center">
										<van-uploader accept="image/*" v-model="idCardFront" :before-read="beforeRead"
											:after-read="afterReadCF" preview-size="3rem"
											:preview-full-image="legalFrontFilePreview">
											<img v-show="idCardFront.length==0" style="width: 5rem; height: 3rem;"
												src="@/assets/images/kuan_gallery.svg">
										</van-uploader>
										<div class="text12 textcolor333 margin_top_1">点击上传身份证人像面照片</div>
									</div>
									<div class="all_text_center">
										<van-uploader accept="image/*" v-model="idCardBack" :before-read="beforeRead"
											:after-read="afterReadCB" preview-size="3rem"
											:preview-full-image="legalBackFilePreview">
											<img v-show="idCardBack.length==0" style="width: 5rem; height: 3rem;"
												src="@/assets/images/kuan_gallery.svg">
										</van-uploader>
										<div class="text12 textcolor333 margin_top_1">点击上传身份证国徽面照片</div>
									</div>
								</div>
							</div>
						</div>
						<div class="all_tips_content_card_padding8 margin_top_8">
							<div class="all_tips_red_after text14 textcolor666">企业名称</div>
							<div class="all_van_field" :class="{ isfocus: enterpriseNameFocus }">
								<van-field v-model="enterpriseName" type="text" placeholder="请输入企业名称" clearable
									@focus="getFocus(1)" @blur="onblur(1)">
								</van-field>
							</div>
							<div class="all_tips_red_after text14 textcolor666 margin_top_5">统一社会信用代码</div>
							<div class="all_van_field" :class="{ isfocus: enterpriseCreditCodeFocus }">
								<van-field v-model="enterpriseCreditCode" type="text" placeholder="请输入企业统一社会信用代码"
									clearable @focus="getFocus(2)" @blur="onblur(2)" :readonly="!canModifyCreditCode">
								</van-field>
							</div>
							<div class="all_tips_red_after text14 textcolor666 margin_top_5">营业执照有效期限</div>
							<div class="all_van_field" :class="{ isfocus: expiryDateFocus }">
								<div class="display_inline_block" style="width: 70%;"
									@click="getEnterpriseExpiryDate()">
									<van-field v-model="enterpriseExpiryDateShow" type="text" placeholder="请输入营业执照有效期"
										clearable readonly @focus="getFocus(4)" @blur="onblur(4)">
									</van-field>
								</div>
								<span @click="setEnterpriseExpiryDate()"
									class="display_inline_block text14 all_text_right all_line_height20 textcolormain"
									style="width: 28%;">长期有效</span>
							</div>
							<!-- <div class="all_tips_red_after text14 textcolor666 margin_top_5">企业注册经营地址</div>
							<div class="all_van_field" :class="{ isfocus: addressFocus }">
								<van-field v-model="enterpriseAddress" type="text" placeholder="请输入企业注册经营地址" clearable
									@focus="getFocus(5)" @blur="onblur(5)">
								</van-field>
							</div> -->
							<div class="all_tips_red_after text14 textcolor666 margin_top_5">法定代表人姓名</div>
							<div class="all_van_field" :class="{ isfocus: enterpriseLegalNameFocus }">
								<van-field v-model="enterpriseLegalName" type="text" placeholder="请输入企业法人姓名" clearable
									@focus="getFocus(3)" @blur="onblur(3)">
								</van-field>
							</div>
							<div class="all_tips_red_after text14 textcolor666 margin_top_5">法人身份证号</div>
							<div class="all_van_field" :class="{ isfocus: legalCodeFocus }">
								<van-field v-model="legalCode" type="text" placeholder="请输入法人身份证号" clearable
									@focus="getFocus(7)" @blur="onblur(7)" @keydown.enter="jump()">
								</van-field>
							</div>
							<!-- <div class="all_tips_red_after text14 textcolor666 margin_top_5">法人身份证号有效期</div>
							<div class="all_van_field" :class="{ isfocus: legalCardDateFocus }">
								<div class="display_inline_block" style="width: 70%;" @click="getLegalCardDate()">
									<van-field v-model="legalCardDate" type="text" placeholder="请输入法人身份证号有效期" readonly
										clearable @focus="getFocus(8)" @blur="onblur(8)">
									</van-field>
								</div>
								<span @click="legalCardDate='长期有效'"
									class="display_inline_block text14 all_text_right all_line_height20 textcolormain"
									style="width: 28%;">长期有效</span>
							</div> -->
							<div class="all_tips_red_after text14 textcolor666 margin_top_5">图形验证码</div>
							<div class="all_van_field" :class="{ isfocus: verifyFocus }">
								<div class="display_inline_block" style="width: 65%;">
									<van-field v-model="verifyCode" type="number" maxlength="6" placeholder="请输入计算结果"
										clearable @focus="getFocus(9)" @blur="onblur(9)">
									</van-field>
								</div>
								<span @click="getPictureImg()" class="display_inline_block" title="看不清,换一个"
									style="width: 35%;">
									<img :src="verifyImg" style="height: 1.8rem;width: 6rem;" fill
										title="看不清,换一个" /></span>
							</div>
						</div>
					</div>
				</div>
				<div class="all_tips_bottom_card">
					<van-checkbox class="text12 textcolor333" v-model="checked">我已阅读并同意 <span class="textcolormain"
							@click="agreementClick()">《实名认证服务协议》</span></van-checkbox>
					<button class="all_button22 width_100 text16 bmain_active margin_top_5"
						@click="sumbit()">同意并继续</button>
				</div>
			</div>
		</div>
		<van-popup v-model:show="flow_path_show" round closeable :style="{ width:'92%',}">
			<div class="all_tips_content_card" @click.stop>
				<p class="all_text text14">{{organizationalTypeText+'认证流程'}}</p>
				<van-steps direction="vertical" active-color="#0277FC" :active="-1">
					<van-step v-for="(item,index) in steps" :key="index">
						<h2 class="all_text text14 textcolor333 font_weight_900">{{item.title}}</h2>
						<p class="all_text text12 textcolor999 margin_top_2" style="white-space: pre-wrap">
							{{item.content}}
						</p>
					</van-step>
				</van-steps>
			</div>
		</van-popup>
		<van-popup v-model:show="showBottom" :overlay="true" position="bottom">
			<div class="selectStyleList">
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="selectType(0)">
					<img style="width:2rem;height: 2rem;  margin:.5rem .8rem;" src="@/assets/images/attorney_auth.svg">
					<div class="display_inline_block" style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900 ">企业</div>
						<div class="text12 textcolor999">适用公司、合伙企业等盈利性组织</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div class="style backgroundC_white bwhite_ative display_flex" @click="selectType(1)">
					<img style="width:2rem;height: 2rem;  margin:.5rem .8rem;" src="@/assets/images/legal_auth.svg">
					<div class="display_inline_block" style="flex:1;">
						<div class="all_height_line16 text14 textcolor333 font_weight_900 ">其他</div>
						<div class="text12 textcolor999">非工商组织类型、如民办非企业单位、事业单位等组织或团体</div>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="all_height_line24 text14 textcolor999 all_text_center" @click="showBottom = false">取&nbsp;消
				</div>
			</div>
		</van-popup>
		<van-popup v-model="dateShow" position="bottom">
			<van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
				:formatter="dateFormatter" @confirm="dateConfirm" @cancel="dateCancel"></van-datetime-picker>
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Field,
		Checkbox,
		Uploader,
		Step,
		Steps,
		DatetimePicker
	} from 'vant';
	import {
		AuthStyleSteps0,
		AuthStyleSteps1
	} from '../../../utils/authStyleData.js';
import {
		closeCurrentPage
	} from '../../../utils/nativeOtherOperate.js';
	export default {
		name: 'authenterpriseinfo',
		components: {
			[Step.name]: Step,
			[Steps.name]: Steps,
			[Uploader.name]: Uploader,
			[Checkbox.name]: Checkbox,
			[Field.name]: Field,
			[DatetimePicker.name]: DatetimePicker,
		},
		data() {
			return {
				//重新认证
				reAuth: '',
				//重新认证企业id
				corpId: '',
				//认证流程是否显示
				flow_path_show: false,
				//组织类型弹窗
				showBottom: false,
				//选择日期弹窗
				dateShow: false,
				//勾选协议
				checked: false,
				//认证流程内容
				steps: [],
				//组织类型
				organizationalType: 0,
				//组织类型文本
				organizationalTypeText: '企业',
				//组织类型提示
				organizationalTypeTips: '适用公司、合伙企业等盈利性组织',
				//法人身份证反面fileId
				legalBackFileId: '',
				//法人身份证反面是否支持预览
				legalBackFilePreview: false,
				//法人身份证正面fileId
				legalFrontFileId: '',
				//法人身份证正面是否支持预览
				legalFrontFilePreview: false,
				//企业营业执照fileId
				licenseFileId: '',
				//营业执照是否支持预览
				licenseFilePreview: false,
				//营业执照
				businessLicense: [],
				//身份证正面
				idCardFront: [],
				//身份证背面
				idCardBack: [],
				//企业名称
				enterpriseNameFocus: false,
				enterpriseName: '',
				//企业信用代码
				enterpriseCreditCodeFocus: false,
				enterpriseCreditCode: '',
				//企业营业执照有效期
				expiryDateFocus: false,
				enterpriseExpiryDate: '',
				enterpriseExpiryDateShow: '',
				//企业地址
				addressFocus: false,
				enterpriseAddress: '',
				//企业法人姓名
				enterpriseLegalNameFocus: false,
				enterpriseLegalName: '',
				//法人身份证号
				legalCodeFocus: false,
				legalCode: '',
				//法人身份证有效期
				legalCardDateFocus: false,
				legalCardDate: '',
				legalCardDateShow: '',
				//图片验证结果
				verifyFocus: false,
				verifyCode: '',
				//验证Id
				verifyId: '',
				//验证图片
				verifyImg: '',
				//时间范围
				minDate: new Date(),
				maxDate: new Date(2100, 11, 31),
				currentDate: new Date(),
				dateType: -1, // 0企业营业执照有效期，1身份证有效期
				//企业信息初始信息
				corpInfo: '',
				//524288
				imageLimitSize: 524288,
				//
				canModifyCreditCode: true,
			}
		},
		//拦截设置前进或后退
		beforeRouteLeave(to, from, next) {
			console.log("auth1-beforeRouteLeave", to, from);
			this.$store.commit('changeEnterpriseAuthDirection', 1)
			if (to.name !== 'authenterpriselegal') {
				this.$store.commit("changeEnterpriseAuthInfo", {})
			}
			console.log('enterpriseAuthInfo', this.$store.state.enterpriseAuthInfo)
			next();
		},
		methods: {
			back(){
				if (this.$route.query.appCode) {
					closeCurrentPage()
				} else {
					this.$router.go(-1)
				}
			},
			//
			getBackFlag() {
				let backFlag = true
				if (this.$store.state.sourceFlag) {
					backFlag = false
				}
				return backFlag
			},
			//
			showSelectOrg() {
				this.showBottom = true
			},
			//下一步
			sumbit() {
				if (!this.checked) {
					this.$Toast('请勾选协议！')
					return
				}
				if (!this.licenseFileId) {
					this.$Toast('请上传营业执照图片！')
					return
				}
				if (!this.legalFrontFileId) {
					this.$Toast('请上传身份证正面图片！')
					return
				}
				if (!this.legalBackFileId) {
					this.$Toast('请上传身份证反面图片！')
					return
				}
				this.enterpriseName = this.enterpriseName.trim()
				this.enterpriseCreditCode = this.enterpriseCreditCode.trim()
				this.enterpriseLegalName = this.enterpriseLegalName.trim()
				this.enterpriseExpiryDate = this.enterpriseExpiryDate.trim()
				this.enterpriseAddress = this.enterpriseAddress.trim()
				this.legalCode = this.legalCode.trim()
				this.legalCardDate = this.legalCardDate.trim()
				//验证工商四要素
				//|| !this.enterpriseAddress
				if (!this.enterpriseName || !this.enterpriseCreditCode || !this.enterpriseLegalName || !this
					.enterpriseExpiryDate) {
					this.$Toast('请补全企业信息！')
					return
				}
				//|| !this.legalCardDate
				if (!this.enterpriseLegalName || !this.legalCode) {
					this.$Toast('请补全法人信息！')
					return
				}
				const idcodeReg18 = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/;
				if (!idcodeReg18.test(this.legalCode)) {
					this.$Toast("请检查法人身份证号是否正确！");
					return
				}
				if (!this.verifyCode) {
					this.$Toast("请输入计算结果！");
					return
				}
				if (!this.corpInfo) {
					this.$Toast("请重新进入页面，没有申请到企业信息！");
					return
				}
				//测试
				// this.jump()
				// return
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/corp/api/submitCorpApply', {
					applierCode: this.$store.state.userInfo.staffCode,
					applierName: this.$store.state.userInfo.staffName,
					corpCode: this.corpInfo.corpCode,
					corpId: this.corpInfo.corpId,
					corpName: this.enterpriseName,
					corpType: this.organizationalType,
					creditCode: this.enterpriseCreditCode,
					legalPerson: this.enterpriseLegalName,
					legalPersonIdCode: this.legalCode,
					licenseEndTime: this.enterpriseExpiryDate,
					legalBackFileId: this.legalBackFileId,
					legalFrontFileId: this.legalFrontFileId,
					licenseFileId: this.licenseFileId,
					verify: {
						code: this.verifyCode,
						id: this.verifyId
					}
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.jump()
					} else {
						this.$Toast(res.message || res.messageDetail || "提交失败，请重试！");
						this.getPictureImg()
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast("提交失败，请重试！");
					this.getPictureImg()
					console.log('submitCorpApply-err=', err)
				})
			},
			jump() {
				//缓存信息
				let authInfo = {
					applierCode: this.$store.state.userInfo.staffCode,
					applierName: this.$store.state.userInfo.staffName,
					corpCode: this.corpInfo.corpCode,
					corpId: this.corpInfo.corpId,
					corpName: this.enterpriseName,
					corpType: this.organizationalType,
					creditCode: this.enterpriseCreditCode,
					legalPerson: this.enterpriseLegalName,
					legalPersonIdCode: this.legalCode,
					licenseEndTime: this.enterpriseExpiryDate,
					licenseFileId: this.licenseFileId,
					legalFrontFileId: this.legalFrontFileId,
					legalFrontFileId: this.legalBackFileId,
				}
				this.$store.commit("changeEnterpriseAuthInfo", authInfo)
				this.$Toast("提交成功！");
				this.$router.push({
					path: '/authenterpriselegal',
					query: {
						corpId: this.corpId,
						reAuth: this.reAuth,
					}
				})
			},
			//获取ocr信息
			getOcrInfo(type, fileId) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/file/api/getOcr?fileId=' + fileId, {}).then(rel => {
					if (rel.success) {
						if (type === 'bl' && rel.data && rel.data.type === 'businessLicense') {
							if (this.enterpriseLegalName && rel.data.map.legalPerson && this.enterpriseLegalName !=
								rel.data.map.legalPerson) {
								this.$Toast("营业执照法人姓名和身份证姓名不一致！");
							}
							if (this.reAuth && this.corpId) {
								this.enterpriseName = rel.data.map.corpName
								this.enterpriseLegalName = rel.data.map.legalPerson
							} else {
								this.enterpriseName = rel.data.map.corpName
								this.enterpriseCreditCode = rel.data.map.creditCode
								this.enterpriseLegalName = rel.data.map.legalPerson
							}
						} else if (type === 'cf' && rel.data && rel.data.type === 'idCard') {
							if (!rel.data.map.address) {
								this.$Toast("请上传身份证人像面图片！");
								return
							}
							if (this.enterpriseLegalName && rel.data.map.name && this.enterpriseLegalName != rel
								.data.map.name) {
								this.$Toast("身份证姓名和营业执照法人姓名不一致！");
							}
							this.legalCode = rel.data.map.idCode
							if (!this.enterpriseLegalName) {
								this.enterpriseLegalName = rel.data.map.name
							}
						} else if (type === 'cb' && rel.data && rel.data.type === 'idCard') {
							if (!rel.data.map.signingAuthority) {
								this.$Toast("请上传身份证国徽面图片！");
							}
						}
					}
				}).finally(() => {
					this.$store.dispatch(this.$LoadShow, false)
				})
			},
			//营业执照 读取文件前
			beforeRead(file) {
				console.log(file)
				if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/jpg') {
					this.$Toast('请选择图片文件');
					return false;
				}
				return true
			},
			afterReadBL(file) {
				//console.log('afterReadBL-=', file)
				this.licenseFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > this.imageLimitSize) {
					this.$store.dispatch(this.$LoadShow, true)
					this.Tool.compressImage(file, this.imageLimitSize, false).then((res) => {
						this.uploadBase64('bl', file, res)
						this.$store.dispatch(this.$LoadShow, false)
					}).catch(err => {
						this.uploadBase64('bl', file, file.content)
						this.$store.dispatch(this.$LoadShow, false)
						console.log('bl', '该图片不支持压缩', err)
					})
				} else {
					this.uploadBase64('bl', file, file.content)
				}
			},
			//身份证正面
			afterReadCF(file) {
				//console.log('afterReadCF-=', file)
				this.legalFrontFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > this.imageLimitSize) {
					this.$store.dispatch(this.$LoadShow, true)
					this.Tool.compressImage(file, this.imageLimitSize, false).then((res) => {
						this.uploadBase64('cf', file, res)
						this.$store.dispatch(this.$LoadShow, false)
					}).catch(err => {
						console.log('cf', '该图片不支持压缩', err)
						this.uploadBase64('cf', file, file.content)
						this.$store.dispatch(this.$LoadShow, false)
					})
				} else {
					this.uploadBase64('cf', file, file.content)
				}
			},
			//身份证背面
			afterReadCB(file) {
				//console.log('afterReadCB--=',file)
				this.legalBackFilePreview = true
				file.status = 'uploading';
				file.message = '上传中...';
				if (file.file.size > this.imageLimitSize) {
					this.$store.dispatch(this.$LoadShow, true)
					this.Tool.compressImage(file, this.imageLimitSize, false).then((res) => {
						//console.log('压缩完成',res)
						this.uploadBase64('cb', file, res)
						this.$store.dispatch(this.$LoadShow, false)
					}).catch(err => {
						console.log('cb', '该图片不支持压缩', err)
						this.uploadBase64('cb', file, file.content)
						this.$store.dispatch(this.$LoadShow, false)
					})
				} else {
					this.uploadBase64('cb', file, file.content)
				}
			},
			//上传营业执照，身份证正反面
			//data.replace(/^data:image\/\w+;base64,/, "")
			uploadBase64(flag, file, data) {
				//console.log('--uploadBase64-=', flag, file, data)
				this.$post('/file/api/saveBase64?resId=' + this.Tool.generateUUID(), {
						base64Data: data,
						clearBg: false,
						fileName: file.file.name
					})
					.then((res) => {
						if (res.success && res.data) {
							file.status = 'success';
							file.message = '上传成功';
							this.getOcrInfo(flag, res.data.fileId)
							switch (flag) {
								case 'bl':
									this.licenseFileId = res.data.fileId
									break;
								case 'cf':
									this.legalFrontFileId = res.data.fileId
									break;
								case 'cb':
									this.legalBackFileId = res.data.fileId
									break;
							}
						} else {
							file.status = 'failed';
							file.message = '上传失败';
						}
					}).catch(err => {
						console.log('/file/api/saveBase64', err)
					})
			},
			//获取文件base64
			getBase64(flag, fileId) {
				if (!this.Tool.isNoEmpty(fileId)) {
					return
				}
				this.$store.dispatch(this.$LoadShowLevel, true)
				this.$get('/file/api/getBase64?fileId=' + fileId)
					.then((res) => {
						this.$store.dispatch(this.$LoadShowLevel, false)
						if (res.success && res.data) {
							let base64 = 'data:image/png;base64,' + res.data
							switch (flag) {
								case 'bl':
									this.businessLicense.push({
										content: base64
									})
									break;
								case 'cf':
									this.idCardFront.push({
										content: base64
									})
									break;
								case 'cb':
									this.idCardBack.push({
										content: base64
									})
									break;
							}
						}
					})
			},
			//获取图片文件流
			getImage(flag, fileId) {
				this.$getFile('/file/api/downloadImage/' + fileId)
					.then((res) => {
						this.legalFrontFileSrc = window.URL.createObjectURL(res)
					})
			},
			//获取焦点
			getFocus(id) {
				switch (id) {
					case 1:
						this.enterpriseNameFocus = true
						break;
					case 2:
						this.enterpriseCodeFocus = true
						break;
					case 3:
						this.enterpriseLegalNameFocus = true
						break;
					case 4:
						this.expiryDateFocus = true
						break;
					case 5:
						this.addressFocus = true
						break;
					case 6:
						this.legalNameFocus = true
						break;
					case 7:
						this.legalCodeFocus = true
						break;
					case 8:
						this.legalCardDateFocus = true
						break;
					case 9:
						this.verifyFocus = true
						break;
				}
			},
			//失去焦点
			onblur(id) {
				switch (id) {
					case 1:
						this.enterpriseNameFocus = false
						break;
					case 2:
						this.enterpriseCodeFocus = false
						break;
					case 3:
						this.enterpriseLegalNameFocus = false
						break;
					case 4:
						this.expiryDateFocus = false
						break;
					case 5:
						this.addressFocus = false
						break;
					case 6:
						this.legalNameFocus = false
						break;
					case 7:
						this.legalCodeFocus = false
						break;
					case 8:
						this.legalCardDateFocus = false
						break;
					case 9:
						this.verifyFocus = false
						break;
				}
			},
			dateFormatter(type, val) {
				//console.log(type)
				//console.log(val)
				return val
			},
			//日期确定
			dateConfirm() {
				//console.log(this.currentDate)
				if (this.dateType === 0) {
					this.enterpriseExpiryDate = this.Tool.getDataISOString(this.currentDate.toISOString())
					this.enterpriseExpiryDateShow = this.Tool.formate(this.currentDate, "yyyy-MM-dd")
				} else if (this.dateType === 1) {
					this.legalCardDate = this.Tool.getDataISOString(this.currentDate.toISOString())
					this.legalCardDateShow = this.Tool.formate(this.currentDate, "yyyy-MM-dd")
				}
				this.dateShow = false
				this.dateType = -1
			},
			//日期取消
			dateCancel() {
				this.dateShow = false
				this.dateType = -1
			},
			//企业营业执照有效期
			setEnterpriseExpiryDate() {
				let date = new Date()
				date.setMonth(11)
				date.setFullYear(2099)
				date.setDate(31)
				this.enterpriseExpiryDateShow = '长期有效'
				this.enterpriseExpiryDate = this.Tool.getDataISOString(date.toISOString())
				//console.log('setEnterpriseExpiryDate', this.enterpriseExpiryDate)
			},
			//企业营业执照有效期
			getEnterpriseExpiryDate() {
				this.dateType = 0
				let date = this.enterpriseExpiryDate.split('-')
				if (date && Array.isArray(date) && date.length == 3) {
					this.currentDate = new Date(date[0], date[1] - 1, date[2])
				}
				this.dateShow = true
				//console.log(this.currentDate)
			},
			//法人身份证有效期
			getLegalCardDate() {
				this.dateType = 1
				let date = this.legalCardDate.split('-')
				if (date && Array.isArray(date) && date.length == 3) {
					this.currentDate = new Date(date[0], date[1] - 1, date[2])
				}
				this.dateShow = true
				//console.log(this.currentDate)
			},
			//选择组织类型
			selectType(type) {
				this.organizationalType = type
				if (type === 0) {
					this.organizationalTypeText = '企业'
					this.organizationalTypeTips = '适用公司、合伙企业等盈利性组织'
				} else {
					this.organizationalTypeText = '其他'
					this.organizationalTypeTips = '非工商组织类型、如民办非企业单位、事业单位等组织或团体'
				}
				this.showBottom = false
			},
			//实人认证协议
			agreementClick() {
				this.$router.push({
					name: 'agreementdetails',
					params: {
						type: 3,
					}
				})
			},
			//获取认证图片
			getPictureImg() {
				this.verifyCode = ''
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/api/getImageCode').then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.verifyId = res.data.verifyId
						this.verifyImg = res.data.srcImg
					} else {
						this.verifyImg = ''
						this.$Toast("未获取到验证图片！");
					}
				}).catch((err) => {
					this.verifyImg = ''
					this.$store.dispatch(this.$LoadShow, false)
					console.log('getImageCode', err)
				});
			},
			//重新认证时获取企业信息
			getReAuthEnterpriseInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/api/getEditCorpApply?corpId=' + this.corpId)
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							//res.data.canModifyCreditCode = false
							this.canModifyCreditCode = res.data.canModifyCreditCode
							// if (res.data.canModifyCreditCode !== undefined && res.data.canModifyCreditCode !==
							// 	null) {
							// 	this.canModifyCreditCode = res.data.canModifyCreditCode
							// }
							//console.log(this.canModifyCreditCode)
							this.selectType(res.data.corpType)
							this.enterpriseName = res.data.corpName
							this.enterpriseCreditCode = res.data.creditCode
							this.enterpriseExpiryDate = res.data.licenseEndTime
							let time = this.Tool.dateFormate(res.data.licenseEndTime,
								'yyyy-MM-dd')
							this.enterpriseExpiryDateShow = (time === '2099-12-31') ? '长期有效' : time
							this.enterpriseLegalName = res.data.legalPerson
							this.legalCode = res.data.legalPersonIdCode
							if (res.data.licenseFileId) {
								this.licenseFileId = res.data.licenseFileId
								this.getBase64('bl', res.data.licenseFileId)
							}
							if (res.data.legalFrontFileId) {
								this.legalFrontFileId = res.data.legalFrontFileId
								this.getBase64('cf', res.data.legalFrontFileId)
							}
							if (res.data.legalBackFileId) {
								this.legalBackFileId = res.data.legalBackFileId
								this.getBase64('cb', res.data.legalBackFileId)
							}
							this.corpInfo = res.data
						}
					})
			},
			//获取新认证企业详情
			getAuthEnterpriseInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/api/getNewCorpApply')
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.corpInfo = res.data
						}
					})
			},
			//初始化
			init() {
				this.reAuth = this.$route.query.reAuth
				this.corpId = this.$route.query.corpId
				this.getPictureImg()
				if (this.$store.state.enterpriseAuthDirection === 2) {
					this.corpId = this.$store.state.enterpriseAuthInfo.corpId
					this.getReAuthEnterpriseInfo()
				} else {
					if (this.reAuth && this.corpId) {
						this.getReAuthEnterpriseInfo()
					} else {
						this.getAuthEnterpriseInfo()
					}
				}
				this.steps = AuthStyleSteps0
			},
		},
		mounted() {
			this.init()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	::v-deep .van-image__img {
		object-fit: contain !important;
	}

	::v-deep .van-cell {
		padding: .5rem .2rem;
	}
</style>